// test2760
(2760 && 0);
